let slideUp = (target, duration=300, callback = null) => {
	duration = ( !isNaN(duration) || duration > 0 ) ? duration : 300;
	clearTimeout( target.dataset.delay );
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.boxSizing = 'border-box';
	target.style.height = target.offsetHeight + 'px';
	target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.dataset.delay = window.setTimeout( () => {
		target.setAttribute('aria-expanded', 'false');
		target.style.display = 'none';
		target.style.removeProperty('height');
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
		//alert("!");
		if ( typeof callback === 'function' ) {
			callback();
		}
	}, duration);
}

let slideDown = (target, duration=300, callback = null) => {
	duration = ( !isNaN(duration) || duration > 0 ) ? duration : 300;
	clearTimeout( target.dataset.delay );

	target.style.removeProperty('display');
	let display = window.getComputedStyle(target).display;

	if (display === 'none') {
		display = 'block';
	}

	target.setAttribute('aria-expanded', 'true');

	target.style.display = display;
	let height = target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight;
	target.style.boxSizing = 'border-box';
	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + 'ms';
	target.style.height = height + 'px';
	target.style.removeProperty('padding-top');
	target.style.removeProperty('padding-bottom');
	target.style.removeProperty('margin-top');
	target.style.removeProperty('margin-bottom');
	target.dataset.delay = window.setTimeout( () => {
		target.style.removeProperty('height');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
		if ( typeof callback === 'function' ) {
			callback();
		}
	}, duration);
}
let slideToggle = (target, duration = 300, callback = null) => {
	duration = ( !isNaN(duration) || duration > 0 ) ? duration : 300;
	if (window.getComputedStyle(target).display === 'none') {
		return slideDown(target, duration, callback);
	} else {
		return slideUp(target, duration, callback);
	}
}
